module.exports = __webpack_public_path__ + "media/images/emblems/Eggiwil-coat_of_arms-3267f06bc35f3c91c5b6040f3a76e8af.svg";